import { render } from "./EditPharmacy.vue?vue&type=template&id=77083ffe&ts=true"
import script from "./EditPharmacy.vue?vue&type=script&lang=ts"
export * from "./EditPharmacy.vue?vue&type=script&lang=ts"

import "./EditPharmacy.vue?vue&type=style&index=0&id=77083ffe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__